export const addParameter = (
  queryString: string,
  parameterName: string,
  parameter: string | null | undefined,
): string => {
  if (parameter) {
    queryString += queryString.length > 0 ? '&' : '?';
    queryString += `${parameterName}=${parameter}`;
  }

  return queryString;
};

export const addParameters = (
  queryString: string,
  parameterName: string,
  parameters: string[] | undefined | null,
): string => {
  if (parameters) {
    for (const parameter of parameters) {
      queryString += queryString.length > 0 ? '&' : '?';
      queryString += `${parameterName}=${parameter}`;
    }
  }

  return queryString;
};
